import * as React from 'react';

import * as IGP from '../input-group-panel';

const _styles = require('./InputGroupPanel.scss');

export const InputGroupPanel = (props: React.PropsWithChildren<IGP.InputGroupPanelProps>) => {
    return (
        <div className={_styles.wrapper}>
            <IGP.InputGroupPanel {...props} children={props.children} />
        </div>
    );
};
